import React, { useEffect, useState } from "react";
import styled from 'styled-components';

// colors
// #FE2F67

// styled components here
const Background = styled.div`
background-color: #E5E5E5; 
height: auto;
width: 100%;
`

const FixedNav = styled.nav`
position: fixed;
width: 100%;
height: 80px;
z-index: 10;
background-color: #fff;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`
const ProgramFormWrapper = styled.div`
width: 83%;
min-height: 400px;
height: auto;
background-color: #fff;
z-index: 5;

margin-left: auto;
margin-right: auto;

// make up for fixed nav
margin-top: 80px;
margin-bottom: 56px;

display: flex;
flex-direction: column;

font-family: 'Inter';

// border: 3px solid black;

h1 {
  font-size: 32px;
  width: fit-content;

  border-bottom: 3px solid #FE2F67;

  margin-left: 6%;
  margin-top: 4%;
}


.vertical-marker-wrapper {
  // border: 1px solid black;
}

.outermost-form-wrapper {
  // border: 1px solid black;

  display: flex;
}

.form-inputs-wrapper {
  // border: 1px solid black;

  width: 100%;
  margin-left: 12%;
}

form {
  width: 100%;
}


.box-one {
  // border: 1px solid black;

  display: flex;
  align-items: center;

  
}

.box-two {
  // border: 1px solid black;

  width: 100%;

  display: flex;
  align-items: center;

  // margin-left: 56px;
  // margin-bottom: 30px;

}

.box-three {
  // border: 1px solid black;

  display:flex;
  align-items: center;
}

.circle {
  height: 32px;
  width: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 500;
  border: 2px solid #FE2F67;
  border-radius: 50%;

  margin-right: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  
}

.circle-1 {

  color: #fff;
  background-color: #FE2F67;
}

.circle-2 {
  color: #FE2F67;
}

.line {


  height: 260px;
  width: 1px;

  background-color: lightgrey;
  
  border: 1px solid lightgrey;
  border-radius: 3px;

  margin-left: 17px;
  margin-right: 36px;
}

.text-input {
  min-width: 400px;
  width: 50vw;

  border: 1px solid grey;
  border-radius: 3px;
}

label {
  line-height: 25px;
}

.program-name {
height: 16px;
margin-bottom: 8px;
}

.program-description {
height: 150px;
margin-bottom: 26px;
}

.program-description::placeholder {
font-style: italic;
padding-top: 10px;
padding-left: 10px;
}

.causes-text-box {
height: 130px;

margin-top: 8px;
margin-left: 56px;
margin-bottom: 35px;
}

.button-wrapper {

  // border: 1px solid black;

  display: flex;
  justify-content: end;

  min-width: 400px;
  width: 50vw;

  margin-left: 58px;
  margin-bottom: 30px;
}

.create-button {

  width: 128px;
  height: 49px;

  border: none;
  border-radius: 6px;

  font-size: 1em;
  font-weight: 600;
  font-family: 'Inter';
  color: #fff;
  background-color: #FE2F67;

  cursor: pointer;

}

`




// main component rendering all other components
function Program() {

  return (
    <>
  
      <Nav />
      <CreateProgramForm  />
      <BackgroundColor />
    </>
  )
}

function BackgroundColor () {
  return (
    <Background></Background>
  )
}

function Nav() {
  return (
    <FixedNav> 
        <br />
        
        <p>This is the "fixed" nav bar, need logos and links added. See <a href="https://www.figma.com/file/CiSpubc7psWb8M9phPhSLh/Benevv-Web-app?node-id=3955%3A61413&t=eSCHWsK2EVu9I6w7-0">design doc.</a> </p>
    </FixedNav>
  )
}

function CreateProgramForm() {

  const [causesArray, setCausesArray] = useState(0);

  // POST request to retrieve "causes" list
  useEffect(() => {
    fetch("https://kharis.external.smarttwigs.io//kharis/api/v1/undertake/retrieveAll")
    .then(res => res.json())
    .then(data => setCausesArray(data))
    .then(() => console.log(causesArray))
  })

  return (

  <Background>
    <ProgramFormWrapper>
    
    
        <h1>Create a program</h1>

      <div className="outermost-form-wrapper">
     

        

        <div className="form-inputs-wrapper">

        

            <div className="box-one">
              <div className="circle circle-1">1</div>
              <h2>Program basic info</h2>
            </div>
              

              {/* input fields for program name and description */}
              <div className="box-two">
               <div className="line"></div>
               
                <form action="program/insertDocument" method="post">
                  <label>
                  Program name:
                  </label>
                  <br />
                  <input type="text" name="program_name" id="name" 
                  className="program-name text-input" />
                  

                  <br  />

                  <label>
                  Program description:
                  </label>
                  <br />
                  <textarea name="program_description" id="description" 
                  className="program-description text-input" placeholder="Enter the description of the program"></textarea>
                  

                  <br  />

                </form>
              </div>

          

          <div>
            <div className="box-three">
              <div className="circle circle-2">2</div>
              <h2>Cause(s)</h2>
            </div>
              
                <input type="text" name="causes" className="causes-text-box text-input" />      

              <div className="button-wrapper"> 
                <input type="submit" value="Create" className="create-button" /> 
              </div>
             
                   
          </div>


        

        </div> 

      </div>  

    </ProgramFormWrapper>
  </Background> 
  )
}

export default Program;